import { useRef } from "react";

import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogTitle,
  Textarea,
} from "shared/components";

export interface AddMessageDialogProps {
  onClickSendMessage: (message: string) => void;
  onOpenChange: (open: boolean) => void;
  open: boolean;
}

export function SendUserMessageDialog({
  onClickSendMessage,
  onOpenChange,
  open,
}: AddMessageDialogProps) {
  const messageRef = useRef<HTMLTextAreaElement | null>(null);

  const handleClickSendMessage = () => {
    if (messageRef.current) {
      onClickSendMessage(messageRef.current.value);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        aria-describedby={undefined}
        className="md:max-w-[680px]"
      >
        <DialogTitle>Send user message</DialogTitle>

        <div>
          <Textarea
            className="h-[100px] text-bodylg"
            id="message-textarea"
            placeholder="Enter message"
            ref={messageRef}
          />
        </div>

        <DialogFooter>
          <Button
            className="border-blue-600 text-blue-600"
            onClick={() => onOpenChange(false)}
            variant="outline"
          >
            Cancel
          </Button>
          <Button
            className="bg-blue-600 text-white"
            onClick={handleClickSendMessage}
            type="submit"
          >
            Send message
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
